<app-navigation></app-navigation>
<app-maintenance></app-maintenance>
<div class="container mainContent">
  <div class="row unselectable headerTitle headline">{{translation.DamageReport}}</div>
  <div class="breakLine"></div>
  <div id="moduleContent" class="row unselectable">
    <app-module *ngIf="damageCaseRecordModule != null" class="cotraModuleCard col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" [module]="damageCaseRecordModule" (click)="navigate(damageCaseRecordModule.ForwardLink)"></app-module>
    <app-module *ngIf="damageCaseOpenModule != null" class="cotraModuleCard col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" [module]="damageCaseOpenModule" (click)="navigate(damageCaseOpenModule.ForwardLink)"></app-module>
    <app-module *ngIf="damageCaseClosedModule != null" class="cotraModuleCard col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" [module]="damageCaseClosedModule" (click)="navigate(damageCaseClosedModule.ForwardLink)"></app-module>
  </div>
</div>
<app-footer></app-footer>
